import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/online-payments/providers', request)
}

export {get}
